import React, { useEffect, useState } from 'react';
import { corrigirSnapDropdown } from '../services/corrigirSnapDropdown';
import { getTotalPosicoes } from '../services/estruturaCategorias';
import { corrigirFlagPorId } from '../services/corrigirFlagPorId';
import { ajusteManualPorId } from '../services/ajusteManualPorId';
import { patchUltimaAtualizacaoPga3321 } from "../services/patchUltimaAtualizacaoPga3321";

import './CorrecaoPorCategoria.css';


function CorrecaoPorCategoria({ modo, categorias, tipo }) {
  const [dados, setDados] = useState({});
  const [carregando, setCarregando] = useState(true);

  // estado da área "recorrigir por ID"
  const [recCatId, setRecCatId] = useState('');
  const [recIdInterno, setRecIdInterno] = useState('');
  const [recLoading, setRecLoading] = useState(false);

  const [ajCatId, setAjCatId] = useState('');
  const [ajIdInterno, setAjIdInterno] = useState('');
  const [ajDeltaPontos, setAjDeltaPontos] = useState(0);
  const [ajDeltaPercent, setAjDeltaPercent] = useState(0);
  const [ajLoading, setAjLoading] = useState(false);

  function normalizarId(id) {
    return id
      .toLowerCase()
      .normalize("NFD") // separa os acentos
      .replace(/[\u0300-\u036f]/g, "") // remove os acentos
      .replace(/\s+/g, ""); // remove espaços
  }

  useEffect(() => {
    if (!modo || !categorias || categorias.length === 0) return;

    // 🔄 Limpa estado anterior ao mudar modo/categorias/tipo
    setDados({});
    setCarregando(true);

    console.log("🟡 Modo atual:", modo);
    console.log("🟡 Categorias recebidas:", categorias.map(c => c.id));

    const novoEstado = {};
    const chaveModo = `${modo}-${tipo}`;

    for (const cat of categorias) {
      const isVencedor = (tipo || "").includes("vencedor");
      const idNormalizado = normalizarId(cat.id);
      const total = isVencedor ? 1 : getTotalPosicoes(chaveModo, idNormalizado);

      if (total == null) {
        console.warn("⚠️ Categoria não encontrada:", idNormalizado, "em modo", chaveModo);
      }

      novoEstado[cat.id] = {
        total: total ?? 5,
        idsCorretos: Array(total ?? 5).fill(""),
        valorAcerto: { verdadeiro: 0, falso: 0 }
      };
    }

    setDados(novoEstado);
    setCarregando(false);

    // define categoria padrão para recorrigir
    if (categorias.length > 0) {
      setRecCatId(categorias[0].id);
    }
    if (categorias.length > 0) {
      setAjCatId(categorias[0].id);
    }
  }, [modo, categorias, tipo]);

  const atualizarId = (categoriaId, index, valor) => {
    setDados((prev) => {
      const novos = [...prev[categoriaId].idsCorretos];
      novos[index] = valor.trim();
      return {
        ...prev,
        [categoriaId]: {
          ...prev[categoriaId],
          idsCorretos: novos
        }
      };
    });
  };

  const atualizarPontos = (categoriaId, tipoPonto, valor) => {
    setDados((prev) => ({
      ...prev,
      [categoriaId]: {
        ...prev[categoriaId],
        valorAcerto: {
          ...prev[categoriaId].valorAcerto,
          [tipoPonto]: Number(valor)
        }
      }
    }));
  };

  const guardar = async (categoriaId) => {
    try {
      const info = dados[categoriaId];
      const { idsCorretos, valorAcerto } = info;

      const idsFiltrados = idsCorretos
      .flatMap((id) => id.split(","))
      .map((id) => id.trim())
      .filter((id) => id.length > 0);

      await corrigirSnapDropdown({
        modo,
        tipo,
        categoriaIds: [categoriaId],
        idsCorretos: idsFiltrados,
        valorTrue: valorAcerto.verdadeiro,
        valorFalse: valorAcerto.falso,
        estruturaPorCategoria: { [categoriaId]: info.total }
      });

      alert(`✅ Correção aplicada em ${categoriaId}`);
    } catch (err) {
      console.error("Erro ao aplicar correção:", err);
      alert("❌ Erro ao aplicar correção. Ver consola.");
    }
  };

  const recorrigirPorId = async () => {
    try {
      if (!recCatId || !recIdInterno.trim()) {
        alert("Preencha a categoria e o ID interno para recorrigir.");
        return;
      }

      setRecLoading(true);

      await corrigirFlagPorId({
        modo,
        tipo,
        categoriaId: recCatId,
        idCorreto: recIdInterno.trim()
      });

      alert(`✅ Flag 'acertou' corrigida para o ID ${recIdInterno.trim()} em ${recCatId}`);
    } catch (err) {
      console.error("Erro ao recorrigir por ID:", err);
      alert("❌ Erro ao recorrigir por ID. Ver consola.");
    } finally {
      setRecLoading(false);
    }
  };

  const aplicarAjusteManualPorId = async () => {
  try {
    if (!ajCatId || !ajIdInterno.trim()) {
      alert("Preencha a categoria e o ID interno para aplicar o ajuste.");
      return;
    }

    const dp = Number(ajDeltaPontos) || 0;
    const dperc = Number(ajDeltaPercent) || 0;

    if (dp === 0 && dperc === 0) {
      alert("Defina pelo menos um valor: pontos ou porcentagem (não pode ser ambos 0).");
      return;
    }

    setAjLoading(true);

    const res = await ajusteManualPorId({
      modo,
      tipo,
      categoriaId: ajCatId,
      idInterno: ajIdInterno.trim(),
      deltaPontos: dp,
      deltaPercent: dperc
    });

    alert(
      `✅ Ajuste aplicado.\n\n` +
      `Usuários afetados: ${res?.afetados ?? "?"}\n` +
      `Usuários ignorados: ${res?.ignorados ?? "?"}\n\n` +
      `Obs: foi atualizado total, ranking e perfil.`
    );
  } catch (err) {
    console.error("Erro ao aplicar ajuste manual por ID:", err);
    alert("❌ Erro ao aplicar ajuste manual. Ver consola.");
  } finally {
    setAjLoading(false);
  }
};


  if (carregando) {
    return (
      <div className="correcao-container">
        <h2>Correção por Categoria</h2>
        <p>A carregar campos de correção...</p>
      </div>
    );
  }

  return (
    <div className="correcao-container">
      <h2>Correção por Categoria</h2>

      {categorias.map((cat) => {
        const info = dados[cat.id];
        if (!info) return null;

        const todosPreenchidos = info.idsCorretos.some((id) => id.trim().length > 0);
        const isVencedor = (tipo || "").includes("vencedor");

        return (
          <div key={cat.id} className="correcao-bloco">
            <h3>
              {cat.nome || cat.id} — {info.total} posição{info.total > 1 ? "s" : ""}
            </h3>

            {[...Array(info.total)].map((_, i) => (
              <label key={i}>
                {isVencedor
                  ? "ID interno correto — Vencedor:"
                  : `ID interno correto — Vaga ${i + 1}:`}
                <input
                  type="text"
                  value={info.idsCorretos[i] || ""}
                  onChange={(e) => atualizarId(cat.id, i, e.target.value)}
                />
              </label>
            ))}

            <label>
              Pontos por acerto:
              <input
                type="number"
                value={info.valorAcerto.verdadeiro}
                onChange={(e) =>
                  atualizarPontos(cat.id, 'verdadeiro', e.target.value)
                }
              />
            </label>

            <label>
              Pontos por erro:
              <input
                type="number"
                value={info.valorAcerto.falso}
                onChange={(e) =>
                  atualizarPontos(cat.id, 'falso', e.target.value)
                }
              />
            </label>

            <button
              onClick={() => guardar(cat.id)}
              disabled={!todosPreenchidos}
              style={{ opacity: todosPreenchidos ? 1 : 0.5 }}
            >
              Aplicar Correção
            </button>
          </div>
        );
      })}

      {/* Bloco extra: recorrigir apenas a flag acertou por ID */}
      <div className="correcao-bloco recorrigir-por-id">
        <h3>Recorrigir por ID interno (sem alterar pontos)</h3>

        <label>
          Categoria:
          <select
            value={recCatId}
            onChange={(e) => setRecCatId(e.target.value)}
          >
            {categorias.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.nome || cat.id}
              </option>
            ))}
          </select>
        </label>

        <label>
          ID interno a marcar como acerto:
          <input
            type="text"
            value={recIdInterno}
            onChange={(e) => setRecIdInterno(e.target.value)}
            placeholder="Ex: 3186"
          />
        </label>

        <button onClick={recorrigirPorId} disabled={recLoading}>
          {recLoading ? "Aplicando..." : "Aplicar recorrigir por ID"}
        </button>

        <p className="hint">
          Esta ação apenas define acertou: true para o ID indicado,
          na categoria escolhida, sem recalcular pontos ou porcentagem.
        </p>
      </div>

      <div className="correcao-bloco recorrigir-por-id">
  <h3>Ajuste manual por ID interno (SOMA pontos e porcentagem)</h3>

  <label>
    Categoria:
    <select
      value={ajCatId}
      onChange={(e) => setAjCatId(e.target.value)}
    >
      {categorias.map((cat) => (
        <option key={cat.id} value={cat.id}>
          {cat.nome || cat.id}
        </option>
      ))}
    </select>
  </label>

  <label>
    ID interno para procurar na categoria:
    <input
      type="text"
      value={ajIdInterno}
      onChange={(e) => setAjIdInterno(e.target.value)}
      placeholder="Ex: 3321"
    />
  </label>

  <label>
    Pontos a somar:
    <input
      type="number"
      value={ajDeltaPontos}
      onChange={(e) => setAjDeltaPontos(e.target.value)}
    />
  </label>

  <label>
    Porcentagem a somar no modo:
    <input
      type="number"
      step="0.1"
      value={ajDeltaPercent}
      onChange={(e) => setAjDeltaPercent(e.target.value)}
    />
  </label>

  <button onClick={aplicarAjusteManualPorId} disabled={ajLoading}>
    {ajLoading ? "Aplicando ajuste..." : "Aplicar ajuste manual por ID"}
  </button>

  <p className="hint">
    Esta ação não recalcula a categoria inteira.
    Ela só aplica o ajuste se o ID existir naquela categoria,
    soma pontos e soma porcentagem, e depois atualiza total, ranking e perfil.
    Se repetir, soma novamente.
  </p>
</div>

<button
  onClick={async () => {
    try {
      const res = await patchUltimaAtualizacaoPga3321();
      alert(`Patch finalizado.\nAfetados: ${res.afetados}\nIgnorados: ${res.ignorados}\nSem dados: ${res.semDados}`);
    } catch (e) {
      console.error(e);
      alert("Erro ao rodar patch. Ver consola.");
    }
  }}
>
  Rodar PATCH PGA 3321 (corrigir ultimaAtualizacao)
</button>

    </div>
  );
}

export default CorrecaoPorCategoria;
